import Vue from 'vue'
// 这个方法不做本地储存，作用就是能够快速获取到kv
export default function(context) {
  const { store, app, router } = context
  const { $axios } = app
  const loading = {}
  const mutations = {
    ADD_COLLECTION(state, { name, list, type }) {
      const collectionMap = {
        ...state.collectionMap,
        [name]: {
          type: type,
          list,
        },
      }
      state.collectionMap = collectionMap
    },
    RESET_COLLECTION(state, name) {
      let collectionMap = {}
      if (name) {
        collectionMap = JSON.parse(JSON.stringify(state.collectionMap))
        delete collectionMap[name]
      }

      state.collectionMap = collectionMap
    },
    RESET_COLLECTION_BY_TYPE(state, type) {
      const collectionMap = JSON.parse(JSON.stringify(state.collectionMap))
      for (const i in collectionMap) {
        if (collectionMap[i].type === type) {
          delete collectionMap[i]
        }
      }
      state.collectionMap = collectionMap
    },
  }
  const actions = {
    // 没统一出口数据格式！！！
    async GetCollection(
      { state, commit },
      name,
      options = {
        type: 'route',
        forceUpdate: true,
      }
    ) {
      if (loading[name]) {
        const res = await loading[name]
        return res.data
      }
      if (!options.forceUpdate) {
        //
        if (state.collectionMap[name]) {
          return state.collectionMap[name]
        }
      }
      const fn = _name => {
        let p
        if (name) {
          p = $axios
            .get('/additional/admin/dictionary/queryByParentKey?parentKey=' + name)
            .then(res => {
              return res.data.map(item => {
                return {
                  label: item.dictionaryName,
                  value: item.dictionaryValue,
                }
              })
            })
        }

        return p
      }
      loading[name] = fn(name)
      // 未找到匹配项返回空列表
      if (!loading[name]) {
        console.warn(`NO_MATCH_COLLECTION_FN:${name}`)
        commit('ADD_COLLECTION', {
          name,
          list: [],
          type: options.type,
        })
      }
      try {
        const result = await loading[name]
        delete loading[name]
        commit('ADD_COLLECTION', {
          name,
          list: result,
          type: options.type,
        })
        return result
      } catch (e) {
        console.log(e)
        return e
      }
    },
  }
  store.registerModule('collectionStore', {
    // namespace: false,
    state: {
      collectionMap: {},
    },
    mutations: mutations,
    actions: actions,
  })
  router.afterEach(() => {
    store.commit('RESET_COLLECTION_BY_TYPE', 'route')
  })
  Vue.mixin({
    computed: {
      $collection() {
        return function(collection) {
          const collectionMap = this.$store.state.collectionStore.collectionMap
          const c = collectionMap[collection]
          if (c) {
            return c.list
          }
          if (!loading[collection]) {
            // 通过store的改变触发视图上$collection值改变
            this.$store.dispatch('GetCollection', collection)
          }
          return []
        }
      },
    },
  })
}
